export default __webpack_public_path__ + "static/media/img-2.c3cd2b55.png";